/**
 * 🔴 US-AIV2-0061-S01 (@UC0178) — 17 TRIGGER của Người dẫn đường, enum ĐÓNG.
 *
 * Cùng nguyên tắc whitelist đóng với `TX_TYPES`/`AccountKind` (CLAUDE.md §3.8) và `SIGNALS` của v1: gõ sai tên trigger
 * là **TS đỏ**, không phải một thẻ im lặng không bao giờ bắn — lỗi tệ nhất của hệ nhắc việc là không ai thấy nó *không* chạy.
 *
 * Luật (ADR-0009): nói khi **thế giới đổi**, không nói khi đồng hồ chạy; một tín hiệu nhắc một lần; **cùng MỘT bảng luật
 * cho mọi trigger** — đó là lý do `journey()` là một hàm, không phải `orchestration.service` + `next-step-turn.service`.
 *
 * 🔴 SỐ 17, KHÔNG PHẢI 16 — đo trên chính danh sách của ADR-0009 §"16 trigger": 8 (người dùng) + 3 (người khác) + 4 (thời gian)
 * + 2 (hệ thống) = **17**. Nhan đề "16" là lỗi cộng trong văn bản, không phải một trigger thừa: bỏ bớt một cái tên cho khớp
 * con số nghĩa là một tình huống có thật vĩnh viễn im lặng. Giữ ĐỦ danh sách, sửa con số (ADR + `@UC0178`).
 * `NEW_CAPABILITY` vẫn NGOÀI enum (ADR ghi "tuỳ chọn, không bắt buộc") — thêm nó là một QĐ, và lưới AC1 sẽ đòi thẻ cho nó.
 */
export const GUIDE_TRIGGERS = [
  // Người dùng làm gì đó (8)
  "OPEN",
  "RETURN_AFTER_ABSENCE",
  "TASK_DONE",
  "ASKED_NEXT",
  "BLOCKED",
  "BEFORE_RISKY_CONFIRM",
  "TASK_FAILED",
  "STUCK",
  // Người khác làm gì đó (3)
  "DUTY_CREATED",
  "MY_ITEM_RESOLVED",
  "MY_ROLE_CHANGED",
  // Thời gian trôi (4) — kênh worker (0063), KHÔNG bắn từ lượt chat
  "DEADLINE_NEAR",
  "STALE",
  "PERIOD_START",
  "MILESTONE",
  // Hệ thống đổi (2)
  "CONFIG_CHANGED",
  "ACCOUNT_RISK",
] as const;

export type GuideTrigger = (typeof GUIDE_TRIGGERS)[number];

/** Trigger nào bắn TRONG một lượt chat (0061 nối) vs trigger của kênh khác (0063 worker) — dữ liệu để gate/PO đọc, engine không rẽ nhánh theo. */
export const GUIDE_TRIGGER_CHANNEL = Object.freeze({
  OPEN: "chat",
  RETURN_AFTER_ABSENCE: "chat",
  TASK_DONE: "chat",
  ASKED_NEXT: "chat",
  BLOCKED: "chat",
  BEFORE_RISKY_CONFIRM: "chat",
  TASK_FAILED: "chat",
  STUCK: "chat",
  DUTY_CREATED: "push",
  MY_ITEM_RESOLVED: "push",
  MY_ROLE_CHANGED: "push",
  DEADLINE_NEAR: "push",
  STALE: "push",
  PERIOD_START: "push",
  MILESTONE: "push",
  CONFIG_CHANGED: "push",
  ACCOUNT_RISK: "push",
} as const satisfies Readonly<Record<GuideTrigger, "chat" | "push">>);

export function isGuideTrigger(value: string): value is GuideTrigger {
  return (GUIDE_TRIGGERS as readonly string[]).includes(value);
}
